var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cmd-toast\u003E\u003Cdiv class=\"md-toast-content md-warn\" style=\"background: #d84040\"\u003E\u003Cspan flex\u003EIhr Kundenkonto ist gesperrt\u003C\u002Fspan\u003E\u003Cmd-button hide-xs ng-click=\"$ctrl.openSupportDialog()\"\u003EKontakt\u003C\u002Fmd-button\u003E\u003Cmd-button ng-click=\"$ctrl.close()\"\u003ESchließen\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-toast\u003E";;return pug_html;};
module.exports = template;


// WEBPACK FOOTER //
// ./app/customers/components/blocked-toast/blocked-toast.template.pug